import { getAuth, browserLocalPersistence } from 'firebase/auth';
import { app } from './firebase';

const AuthenticationInstance = getAuth(app);

AuthenticationInstance.setPersistence(browserLocalPersistence);
export const auth = AuthenticationInstance;
